import { resolveSplitTreatment } from './resolveSplitTreatment';

export const resolveSplitFlag = async ({ dispatch, getState, splitName }) => {
  const { treatment } = await resolveSplitTreatment({ dispatch, getState, splitName });
  return treatment === 'on';
};
